import size from 'lodash/size';
import { format, parseISO } from 'date-fns';
import isArray from 'lodash/isArray';
import get from 'lodash/get';
import * as locale from 'date-fns/locale';
import { currencyFormatter } from '../helper';

export const Mapper = (data) => {
  let property = {};

  if (data) {
    property['columns'] = data?.headers;
    property['polling'] = data?.polling;
    property['pollingInterval'] = data?.pollingInterval;
  }
  if (size(data.data)) {
    property['data'] = [];

    data.data.map((itm) => {
      let tempData = itm;
      tempData = {
        ...tempData,
        content: true,
        linkAllRegs:
          '/api/imports/importDrivers/{id}?show=all&length={length}&page={page}',
        linkProbRegs:
          '/api/imports/importDrivers/{id}?show=fail&length={length}&page={page}',
      };

      property['columns'].map((col) => {
        if (col.type === 'date') {
          tempData[col.name] = tempData
            ? format(parseISO(tempData[col.name]), 'dd MMMM yyyy hh:mm a', {
                locale: locale['el'],
              })
            : '-';
        }
        if (col.type === 'shortDate') {
          tempData[col.name] = tempData
            ? format(parseISO(tempData[col.name]), 'dd/MM/yyyy', {
                locale: locale['el'],
              })
            : '-';
        }
        if (col.type === 'shortDatetime') {
          tempData[col.name] = tempData
            ? format(parseISO(tempData[col.name]), 'dd/MM/yyyy HH:mm ', {
                locale: locale['el'],
              })
            : '-';
        }
      });
      property['data'].push(tempData);
    });

    if (!property['columns'].find((el) => el['name'] === 'collapseAll')) {
      property['columns'].push({
        label: 'Όλες οι εγγραφές',
        name: 'collapseAll',
        type: 'button',
      });
    }
    property['columns'].forEach((col) => {
      col['show'] = true;
    });
  }
  if (property['columns'] && !property['data']) {
    property['data'] = [];
  }
  return property;
};

export const MapperAll = (data) => {
  let property = {};
  if (data) {
    property['columns'] = data.columns;
    property['pagination'] = {
      current_page: data['current_page'],
      first_page_url: data['first_page_url'],
      last_page_url: data['last_page_url'],
      links: data['links'],
      next_page_url: data['next_page_url'],
      prev_page_url: data['next_page_url'],
      per_page: data['per_page'],
    };
    property['records'] = {
      from: data['from'],
      to: data['to'],
      total: data['total'],
      allCount: data['allCount'],
    };
    property['dataSize'] =
      data['dataSize']?.length &&
      data['dataSize'].map((el) => {
        if (el > 0) {
          return { name: el, value: el };
        } else {
          return { name: 'Όλα', value: el };
        }
      });
  }
  if (size(data.data)) {
    property['data'] = [];
    data.data.map((entry) => {
      let tempData = entry.entryData;
      const { id, import_bulk_id, reason, status } = entry;
      tempData = { ...tempData, id, import_bulk_id, reason, status };
      property['data'].push(tempData);
    });
    property['columns'].forEach((col) => (col['show'] = true));
  }
  property['handlingItem'] = data;
  return property;
};

export const MapperOfferCheck = (data) => {
  let property = {};

  if (data) {
    if (size(data.data)) {
      property['columns'] = [];
      property['data'] = [];

      data.data.forEach((itm) => {
        const headers = itm.dataShow.header;
        if (!property['columns'].length) {
          property['columns'].push(...headers);
        } else {
          headers.forEach((header) => {
            const findData = property['columns'].find(
              (el) => el.name === header.name
            );
            if (!findData) {
              property['columns'].push(header);
            }
          });
        }

        let tempData = itm['data'];

        const item = itm['actions'].find((el) => el.name === 'expand');
        item && (tempData = { ...tempData, content: true, link: item.url });
        property['data'].push(tempData);
      });

      if (!property['columns'].find((el) => el['name'] === 'action')) {
        property['columns'].push({
          label: 'action',
          name: 'action',
          type: 'button',
        });
      }
      property['columns'].forEach((col) => (col['show'] = true));
    }
  }
  return property;
};

export const MapperOfferCheckDetails = (offerData) => {
  let output = {};

  if (offerData) {
    if (size(offerData.data)) {
      const expandedData = {
        actions: offerData.data?.actions,
        data: offerData.data?.data,
      };

      const {
        actions: detailsActions,
        dataShow: {
          customerDetails,
          documents,
          newCustomerForm: customerForm,
          offerDetails,
        },
      } = offerData.data;

      const newCustomerDetails = {};
      customerDetails.forEach((el) => {
        let name = el.name;
        if (name.includes('.')) {
          name = name.split('.');
          newCustomerDetails[name.slice(-1)] = el;
          newCustomerDetails[name.slice(-1)]['value'] = get(
            expandedData.data,
            name,
            ''
          );
        } else {
          newCustomerDetails[name] = el;
          newCustomerDetails[name]['value'] = expandedData.data[name];
        }
      });

      const newOfferDetails = {};
      offerDetails.forEach((el) => {
        const name = el.name;
        newOfferDetails[name] = el;
        newOfferDetails[name]['value'] = expandedData.data[name];

        isArray(newOfferDetails[name]['value']) &&
          (newOfferDetails[name]['value'] =
            newOfferDetails[name]['value'].join(', '));

        newOfferDetails[name]['type'] === 'currency' &&
          (newOfferDetails[name]['value'] = currencyFormatter(
            expandedData.data[name]
          ));

        newOfferDetails[name]['value'] &&
          newOfferDetails[name]['type'] === 'int' &&
          (newOfferDetails[name]['value'] = new Intl.NumberFormat(
            'el-GR'
          ).format(expandedData.data[name]));
      });

      const newCustomerForm = {};
      newCustomerForm['actions'] = customerForm['actions'] || '';
      newCustomerForm['data'] = {};
      customerForm.fields.forEach((el) => {
        let name = el.name;
        if (name.includes('.')) {
          name = name.split('.');
          newCustomerForm['data'][name.slice(-1)] = el;
          newCustomerForm['data'][name.slice(-1)]['value'] = get(
            expandedData.data,
            name,
            ''
          );
        } else {
          newCustomerForm['data'][name] = el;
          newCustomerForm['data'][name]['value'] = expandedData.data[name];
        }
        newCustomerForm['data']['id'] =
          expandedData.data['newCustomerForm']['id'];
      });

      const newDocuments = {};
      newDocuments['data'] = [];
      expandedData['data'].documents.forEach((el) => {
        documents.fields.forEach((doc) => {
          let name = doc.name;

          if (name.includes('.')) {
            [name] = name.split('.').slice(-1);
          }

          if (el[name]) {
            el[name] = {
              name,
              label: doc.label,
              type: doc.type,
              value: el[name].value || el[name],
            };
          }
        });
        el['actions'] = documents['actions'] || '';
        newDocuments['data'].push(el);
      });

      output = {
        actions: detailsActions,
        customerDetails: newCustomerDetails,
        offerDetails: newOfferDetails,
        customerForm: newCustomerForm,
        documents: newDocuments,
      };
    }
  }

  return output;
};
